import {
    deviceAssignmentReasonsFulfilledConstants,
    deviceAssignmentReasonsPendingConstants,
    deviceAssignmentReasonsRejectedConstants
} from '../actions/deviceAssignmentReasons';

const initialState = {
    data: [],
    error: '',
    loading: true
};

export default function (state = initialState, action) {
    switch (action.type) {
        case deviceAssignmentReasonsPendingConstants.DEVICE_ASSIGNED_REASON_LOADED:
            return initialState;
        case deviceAssignmentReasonsFulfilledConstants.DEVICE_ASSIGNED_REASON_LOADED:
            return {
                ...initialState,
                data: {
                    total: action.payload.total,
                    items: action.payload.items
                        .sort((a, b) => {
                            if (a.name < b.name) return -1;
                            if (a.name > b.name) return 1;
                            return 0;
                        })
                },
                loading: false
            };

        case deviceAssignmentReasonsFulfilledConstants.DEVICE_ASSIGNED_REASON_CREATED:
            return { ...initialState,
                loading: false,
                data: {
                    ...state.data,
                    item: [...state.data.items, action.payload]
                } };
        case deviceAssignmentReasonsFulfilledConstants.DEVICE_ASSIGNED_REASON_UPDATED:
            return { ...state,
                loading: false,
                data: { total: action.payload?.total ? action.payload.total : state.data.total,
                    items: state.data.items.map(c => (c.id === action.payload.id ? action.payload : c)) } };

        case deviceAssignmentReasonsPendingConstants.DEVICE_ASSIGNED_REASON_CREATED:
        case deviceAssignmentReasonsPendingConstants.DEVICE_ASSIGNED_REASON_UPDATED:
            return { ...state, loading: true };

        case deviceAssignmentReasonsFulfilledConstants.DEVICE_ASSIGNED_REASON_DELETED:
            return { ...state,
                data: {
                    total: action.payload?.total ? action.payload.total : state.data.total,
                    items: state.data.items.filter(c => c.id !== action.payload)
                } };

        case deviceAssignmentReasonsRejectedConstants.DEVICE_ASSIGNED_REASON_CREATED:
        case deviceAssignmentReasonsRejectedConstants.DEVICE_ASSIGNED_REASON_UPDATED:
        case deviceAssignmentReasonsRejectedConstants.DEVICE_ASSIGNED_REASON_DELETED: {
            const error = action.payload;

            if (error.response) {
                return {
                    ...state,
                    loading: false,
                    error: `${error.response.data.errorMessage || error.response.status + ' ' + error.response.statusText}`,
                    ...error.response.data
                };
            } else if (error) {
                return {
                    ...state,
                    loading: false,
                    error: error.message
                };
            }

            return state;
        }
        default:
            return state;
    }
}
